module.exports = __webpack_public_path__ + "static/img/LoadingScreen.20fcabf.gif";